<script>
export default {
  directives: {
    check: {
      bind: function (el, binding, vnode) {
        if (typeof binding.value === 'function') {
          const check = binding.value
          const vm = vnode.context
          const realCheck = fromAll => {
            return check({
              val: el.value,
              fromAll
            })
          }
          vm.needChecks.push(realCheck)
          el.addEventListener(
            'input',
            function (evt) {
              const res = realCheck()
              if (!res.validate) {
                vm.$toast({
                  message: res.errmsg,
                  duration: 1500
                })
              } else {
              }
            },
            false
          )
        }
      }
    }
  },
  data() {
    return {
      needChecks: []
    }
  },
  methods: {
    checkAll() {
      return this.needChecks
        .map(check => {
          return check('ALL')
        })
        .filter(res => {
          return !res.validate
        })
        .map(res => {
          return res.errmsg
        })
    },
    // 校验条形码
    checkQRCode({ val, fromAll }) {
      const barCode = val
      const barLen = barCode.length || 0
      const checkRepeat = str => {
        const dict = str.split('').reduce((data, num) => {
          data[num] = true
          return data
        }, {})

        return Object.keys(dict).length === 1
      }

      let res = true
      if (fromAll) {
        res =
          barCode === '' ||
          (barCode &&
            (barLen === 8 || barLen === 13) && // 8或13位
            /^\d+$/.test(barCode) && // 必须为数字
            !checkRepeat(barCode)) // 不能全为重复数字
      } else if (barCode !== '') {
        // 输入时采用部分验证
        if (barLen > 8 && barLen !== 13) {
          res = false
        }

        if (!/^\d+$/.test(barCode)) {
          res = false
        }

        if (barLen >= 8 && checkRepeat(barCode)) {
          res = false
        }
      }

      return res
        ? {
            validate: true
          }
        : { validate: false, errmsg: '输入8位或13位正确数字条形码' }
    }
  }
}
</script>
